import React from 'react'
import { navData } from './navData'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { supabase } from '../../supabase'

const Navbar = () => {


    const { user } = useAuth()
    const navigate = useNavigate()

    const handleLogout = async () => {
        await supabase.auth.signOut()
        navigate('/')
    }


    return (
        <>
            {/* {user && (<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
                <a class="navbar-brand" href="#">Navbar</a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">
                        {
                            navData.map((data, ind) => {
                                return (
                                    <Link to={data.route} class="nav-item active text-decoration-none nav-link ">
                                        {data.name}
                                    </Link>
                                )
                            })

                        }

                    </ul>
                    <div class="form-inline my-2 my-lg-0">
                        <span className='mr-4 text-white'>{user.email}</span>
                        <button onClick={handleLogout} className='btn btn-danger'>Logout</button>
                    </div>
                </div>

            </nav>)} */}

            {user && (<header id="header" class="header d-flex align-items-center fixed-top">
                <div class="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between">

                    <Link to={'/'} class="logo d-flex align-items-center me-auto me-xl-0">
                        {/* <!-- Uncomment the line below if you also wish to use an image logo --> */}
                        {/* <!-- <img src="assets/img/logo.webp" alt=""/> --> */}
                        <h1 class="sitename text-white">Rkivedocs</h1>
                    </Link>

                    <nav id="navmenu" class="navmenu">
                        <ul >
                            {
                                navData.map((data, ind) => {
                                    return (
                                        <Link to={data.route} class="">
                                            {data.name}
                                        </Link>
                                    )
                                })

                            }

                        </ul>
                        <i class="mobile-nav-toggle d-xl-none bi bi-list"></i>
                    </nav>

                    <div class="form-inline my-2 my-lg-0">
                        <span className='mr-4 text-white'>{user.email}</span>
                        <button onClick={handleLogout} className='btn btn-danger'>Logout</button>
                    </div>


                </div>
            </header>)}
        </>
    )
}

export default Navbar